<template>
<v-card
    class="mx-auto"
    max-width="400"
  >
    <v-img
      class="white--text align-end"
      height="200px"
      src="../assets/forest.jpg"
    >
      <v-card-title>Login Serenity</v-card-title>
    </v-img>

    <v-card-text class="text--primary text-center">
      <v-alert type="error" v-if="alert">
      Schlechte IDs
    </v-alert>
      <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-text-field
      v-model="name"
      label="Name"
      required
    ></v-text-field>

    <v-text-field
      v-model="pass"
      type="password"
      label="Passworte"
      required
    ></v-text-field>

    <v-checkbox
      v-model="checkbox"
      label="Behalte mich in Erinnerung"
    ></v-checkbox>

    <v-btn
      :disabled="!valid"
      color="success"
      @click="sendLogin"
    >
      Einloggen
    </v-btn>
  </v-form>
    </v-card-text>

    <v-card-actions>

    </v-card-actions>
  </v-card>
</template>

<script>
  import {ajax_post} from '../../public/global.js'
  export default {
    data: () => ({
      valid: true,
      name: '',
      pass: '',
      checkbox: false,
      alert: false
    }),

    methods: {
      sendLogin () {
        ajax_post(`/PHP/ajax/login.php`, `name=${this.name}&pass=${this.pass}&remember=${this.checkbox}`).then((response) =>{
          let rep = JSON.parse(response)
          if(rep.token.length > 30){
            if(rep.remember){
              localStorage.setItem('token', rep.token)
              this.$router.push({path: '/'})
            }else{
              sessionStorage.setItem('token', rep.token)
              this.$router.push({path: '/'})
            }
          }else{
            this.alert=true
          }
        })
      }
    },
  }
</script>